import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import YouTube from "react-youtube";
import afogamentoIconUrl from "../assets/images/afogamento.png";
import contusaoIconUrl from "../assets/images/contusao.png";
import contusaoAgirImgUrl from "../assets/images/contusao_agir.png";
import criseConvulsivaIconUrl from "../assets/images/crise_convulsiva.png";
import criseConvulsivaAgirImgUrl from "../assets/images/crise_convulsiva_agir.png";
import desmaioIconUrl from "../assets/images/desmaio.png";
import desmaioAgirImgUrl from "../assets/images/desmaio_agir.png";
import engasgoIconUrl from "../assets/images/engasgo.png";
import engasgoAgirImgUrl from "../assets/images/engasgo_agir.png";
import ferimentoHemorragiaIconUrl from "../assets/images/ferimento_hemorragia.png";
import ferimentoHemorragiaAgirImgUrl from "../assets/images/ferimento_hemorragia_agir.png";
import paradaCardiorrespiratoriaIconUrl from "../assets/images/parada_cardiorespiratoria.png";
import queimaduraIconUrl from "../assets/images/queimadura.png";
import queimaduraAgirImgUrl from "../assets/images/queimadura_agir.png";
import sangramentoNasalAgirImgUrl from "../assets/images/sangramento_nasal_agir.png";
import traumaCabecaIconUrl from "../assets/images/trauma_cabeca.png";
import traumaDenteIconUrl from "../assets/images/trauma_dente.png";

export function Training() {
  const { t, i18n } = useTranslation("global");

  //i18n.language === "pt_pt" ? "BR" : "PT"
  let paradaVideoId = i18n.language === "pt_pt" ? "ZmnCvbJT3_g" : "7AqlS8hHP4Y";
  let engasgoVideoId = i18n.language === "pt_pt" ? "VP8iOUXzr4U" : "BWWp0AmIzuo";

  useEffect(() => {
    paradaVideoId = i18n.language === "pt_pt" ? "ZmnCvbJT3_g" : "7AqlS8hHP4Y";
    engasgoVideoId = i18n.language === "pt_pt" ? "VP8iOUXzr4U" : "BWWp0AmIzuo";
  }, [i18n.language]);

  return (
    <div className="container" style={{ backgroundColor: "#e1d3e6" }}>
      <main>
        <div className="p-3 text-center">
          <span
            className="pb-2"
            style={{
              color: "#6A2481",
              fontFamily: "Poppins",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
            }}
          >
            {/* Aprenda Primeiros Socorros */}
            {t("training.aprendaPrimeirosSocorros")}
          </span>
        </div>
        <div className="accordion" id="accordionExample">
          {/* Parada Cardiorrespiratória */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={paradaCardiorrespiratoriaIconUrl} />
                <span className="p-2">{t("training.paradaCardiorrespiratoria")}</span>
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i> {t("training.paradaCardiorrespiratoriaDescricao")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.paradaCardiorrespiratoriaComoAgir")} <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.paradaCardiorrespiratoriaVideo")}
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {/* COMO AGIR DIANTE DE UMA CRIANÇA EM PARADA CARDIORRESPIRATÓRIA */}
                  {t("training.paradaCardiorrespiratoriaTitulo")}
                </span>
              </div>
              <div className="embed-responsive embed-responsive-21by9">
                <YouTube
                  videoId={paradaVideoId}
                  opts={{
                    height: "186",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoplay: 0,
                    },
                  }}
                />
              </div>
            </div>
          </div>
          {/* Engasgo */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={engasgoIconUrl} />
                <span className="p-2">{t("training.engasgo")}</span>
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i> {t("training.engasgoDescricao")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.engasgoVideo")}
              </div>
              <div className="text-center">
                <img src={engasgoAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.engasgoComoAgir")}
                </span>
              </div>
              <div className="embed-responsive embed-responsive-21by9">
                <YouTube
                  videoId={engasgoVideoId}
                  opts={{
                    height: "186",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoplay: 0,
                    },
                  }}
                />
              </div>
            </div>
          </div>
          {/* Afogamento */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={afogamentoIconUrl} />
                <span className="p-2">{t("training.afogamento")}</span>
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i> {t("training.afogamentoDescricao")}
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.afogamentoComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i> {t("training.afogamentoParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.afogamentoParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.afogamentoParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.seEstiverAcordado")}
                <div className="m-2 mx-4">
                  {t("training.seEstiverAcordadoComoAgir")}
                  <br />
                  {t("training.seEstiverAcordadoComoAgir2")}
                </div>
                <br />
                <i className="bi bi-dot"></i> {t("training.seEstiverInconsciente")}
                <div className="m-2 mx-4">
                  {t("training.seEstiverInconscienteComoAgir")}
                  <br />
                  {t("training.seEstiverInconscienteComoAgir2")}
                  <a
                    data-bs-toggle="collapse"
                    href="#collapseOne"
                    aria-expanded="false"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >
                    {t("training.paradaCardiorrespiratoria")}
                  </a>
                </div>
                <br />
                <i className="bi bi-dot"></i> {t("training.afogamentoParadaparadaCardiorrespiratoria")}
              </div>
            </div>
          </div>
          {/* Crise convulsiva */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={criseConvulsivaIconUrl} />
                <span className="p-2">{t("training.criseConvulsiva")}</span>
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i> {t("training.criseConvulsivaDescricaoParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i> {t("training.criseConvulsivaDescricaoParagrafo2")}
              </div>
              <div className="text-center">
                <img src={criseConvulsivaAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.criseConvulsivaComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo5")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo6")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo7")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.criseConvulsivaParagrafo8")}
              </div>
            </div>
          </div>
          {/* Desmaio */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFive">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={desmaioIconUrl} />
                <span className="p-2">{t("training.desmaio")}</span>
              </button>
            </h2>
            <div
              id="collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="headingFive"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.desmaioDescricaoParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioDescricaoParagrafo2")}
              </div>
              <div className="text-center">
                <img src={desmaioAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.desmaioComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo2")}
                <p className="m-4">
                  - {t("training.desmaioParagrafo3")}{" "}
                  <a
                    data-bs-toggle="collapse"
                    href="#collapseOne"
                    aria-expanded="false"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >
                    {t("training.paradaCardiorrespiratoria")}
                  </a>
                </p>
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo5")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo6")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo7")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo8")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.desmaioParagrafo9")}
              </div>
            </div>
          </div>
          {/* Trauma na cabeça */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSix">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={traumaCabecaIconUrl} />
                <span className="p-2">{t("training.traumaNaCabeca")}</span>
              </button>
            </h2>
            <div
              id="collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="headingSix"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.traumaNaCabecaDescricao")}
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.traumaNaCabecaComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.traumaNacabecaParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNacabecaParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNacabecaParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNacabecaParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNacabecaParagrafo5")}
              </div>
            </div>
          </div>
          {/* Ferimento e hemorragia */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSeven">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={ferimentoHemorragiaIconUrl} />
                <span className="p-2">{t("training.ferimentoEHemorragia")}</span>
              </button>
            </h2>
            <div
              id="collapseSeven"
              className="accordion-collapse collapse"
              aria-labelledby="headingSeven"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaDescricao")}
              </div>
              <div className="text-center">
                <img src={ferimentoHemorragiaAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.ferimentoEHemorragiaComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo4")}
                <br />
                <div className="m-4 mx-4">- {t("training.ferimentoEHemorragiaParagrafo5")}</div>
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo6")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaParagrafo7")}
                <br />
                <br />
                <div className="m-3 fw-bold">{t("training.ferimentoEHemorragiaSangramentoNasal")}</div>
                <div className="text-center">
                  <img src={sangramentoNasalAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                  <br />
                  <span
                    title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                    style={{
                      color: "#6A2481",
                      textAlign: "justify",
                      fontFamily: "Inter",
                      fontSize: "4px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "150%",
                    }}
                  >
                    Imagem: FRANÇOSO; MALVESTIO, 2007.
                  </span>
                </div>
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo5")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.ferimentoEHemorragiaSangramentoNasalParagrafo6")}
              </div>
            </div>
          </div>
          {/* Contusão, entorse e fratura */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingEight">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={contusaoIconUrl} />
                <span className="p-2">{t("training.contusao")}</span>
              </button>
            </h2>
            <div
              id="collapseEight"
              className="accordion-collapse collapse"
              aria-labelledby="headingEight"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.contusaoDescricaoParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.contusaoDescricaoParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.contusaoDescricaoParagrafo3")}
              </div>
              <div className="text-center">
                <img src={contusaoAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.contusaoComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.contusaoParagrafo1")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.contusaoParagrafo2")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.contusaoParagrafo3")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.contusaoParagrafo4")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.contusaoParagrafo5")}
              </div>
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.fraturaComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo1")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo2")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo3")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo4")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo5")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo6")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo7")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo8")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.fraturaParagrafo9")}
              </div>
            </div>
          </div>
          {/* Trauma no dente */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingNine">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={traumaDenteIconUrl} />
                <span className="p-2">{t("training.traumaNoDente")}</span>
              </button>
            </h2>
            <div
              id="collapseNine"
              className="accordion-collapse collapse"
              aria-labelledby="headingNine"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteDescricao")}
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.traumaNoDenteComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo1")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo2")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo3")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo5")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.traumaNoDenteParagrafo6")}
              </div>
            </div>
          </div>
          {/* Queimadura */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
                style={{
                  color: "#FFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "900",
                  lineHeight: "normal",
                  background: "#E8335E",
                }}
              >
                <img src={queimaduraIconUrl} />
                <span className="p-2">{t("training.queimadura")}</span>
              </button>
            </h2>
            <div
              id="collapseTen"
              className="accordion-collapse collapse"
              aria-labelledby="headingTen"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ textAlign: "justify" }}>
                <i className="bi bi-dot"></i>
                {t("training.queimaduraDescricao")}
              </div>
              <div className="text-center">
                <img src={queimaduraAgirImgUrl} title="Imagem: FRANÇOSO; MALVESTIO, 2007." />
                <br />
                <span
                  title="Imagem: FRANÇOSO; MALVESTIO, 2007."
                  style={{
                    color: "#6A2481",
                    textAlign: "justify",
                    fontFamily: "Inter",
                    fontSize: "4px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "150%",
                  }}
                >
                  Imagem: FRANÇOSO; MALVESTIO, 2007.
                </span>
              </div>
              <br />
              <div
                style={{
                  textAlign: "center",
                  background: "#6A2481",
                  height: "80px",
                  alignItems: "center",
                  display: "grid",
                }}
              >
                <span
                  className="p-2"
                  style={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {t("training.queimaduraComoAgir")}
                </span>
              </div>
              <div
                className="p-2"
                style={{
                  color: "#6A2481",
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "12px",
                  fontStyle: "normal",
                  lineHeight: "150%",
                  backgroundColor: "#e1d3e6",
                }}
              >
                <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo1")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo2")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo3")}
                <br />
                <br /> <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo4")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo5")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo6")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo7")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.queimaduraParagrafo8")}
                <br />
                <br />
                <i className="bi bi-dot"></i>
                {t("training.seHouverChamasNoCorpoComoAgir")}
                <p className="m-4">
                  - {t("training.seHouverChamasNoCorpoParagrafo1")}
                  <br />
                  <br />- {t("training.seHouverChamasNoCorpoParagrafo2")}
                  <br />
                  <br />- {t("training.seHouverChamasNoCorpoParagrafo3")}
                </p>
                <i className="bi bi-dot"></i>
                {t("training.seQueimaduraChoqueEletricoComoAgir")}
                <p className="m-4">
                  - {t("training.seQueimaduraChoqueEletricoParagrafo1")}
                  <br />
                  <br />- {t("training.seQueimaduraChoqueEletricoParagrafo2")}
                  <br />
                  <br />- {t("training.seQueimaduraChoqueEletricoParagrafo3")}
                  <br />
                  <br />- {t("training.seQueimaduraChoqueEletricoParagrafo4")}{" "}
                  <a
                    data-bs-toggle="collapse"
                    href="#collapseOne"
                    aria-expanded="false"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >
                    {t("training.paradaCardiorrespiratoria")}
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <br />
      {/* Referências */}
      <div className="my-3">
        <div
          className="col-md-12 text-center"
          style={{
            background: "#6A2481",
            borderRadius: "8px",
            color: "#FFF",
            height: "40px",
          }}
        >
          <span style={{ verticalAlign: "sub", fontWeight: "bold" }}>
            REFERÊNCIAS {/*  <i className="bi bi-person-square"></i> */}
          </span>
        </div>
      </div>
      <div
        style={{
          borderRadius: "8px",
          border: "1px solid rgba(106, 36, 129, 0.25)",
          background: "white",
          //textAlign: "justify",
        }}
      >
        <div className="m-4">
          <b>- Imagens</b>
          <br />
          FRANÇOSO, L. A.; MALVESTIO, M.A.{" "}
          <b>Manual de prevenção de acidentes e primeiros socorros na escola.</b> Secretaria da Saúde.
          Coordenação de Desenvolvimento de Programas e Políticas de Saúde. CODEPPS. São Paulo: SMS, 2007.
          129p.
          <br />
          <br />
          <b>- Texto</b>
          <br />
          PELLEGRINO, J. L. et al. 2020 American Heart Association and American Red Cross focused update for
          First Aid. <b>Circulation</b>, v. 142, n. 17. 2020.{" "}
          <a href="https://doi.org/10.1161/CIR.0000000000000900" target="_blank">
            https://doi.org/10.1161/CIR.0000000000000900
          </a>
          <br />
          <br />
          SZPILMAN, D. et al. <b>Afogamentos:</b> emergências aquáticas – Manual resumido 2023. Sociedade
          Brasileira de Salvamento Aquático, 2023. Disponível em: www. sobrasa.org
        </div>
      </div>
      <br />
    </div>
  );
}
